import { AutocompleteProps } from '@mui/material'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import { TextFieldProps } from '@mui/material/TextField/TextField'
import { useField } from 'formik'
import React, { useCallback } from 'react'

interface FormikAutocompleteProps<
  T,
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined
> extends AutocompleteProps<T, Multiple, DisableClearable, FreeSolo> {
  name: string
  textFieldProps?: TextFieldProps
  isDefaultRenderInput?: boolean
}

const FormikAutocomplete = <
  T,
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined
>({
  name,
  isDefaultRenderInput,
  textFieldProps,
  options,
  ...props
}: FormikAutocompleteProps<
  T,
  Multiple,
  DisableClearable,
  FreeSolo
>): JSX.Element => {
  const [field, { error, touched }, { setValue }] = useField(name)

  const handleChange = useCallback(
    (e, newVal) => {
      if (props.multiple) {
        setValue(newVal || [])
      } else {
        setValue(newVal)
      }
    },
    [setValue]
  )
  return (
    <Autocomplete
      // size='small'
      fullWidth
      disableClearable
      options={options || []}
      value={field.value}
      onChange={handleChange}
      autoComplete={false}
      {...props}
      renderInput={
        isDefaultRenderInput
          ? (params: any) => (
              <TextField
                {...params}
                name={name}
                variant='outlined'
                color='secondary'
                {...(textFieldProps || {})}
                error={!!(touched && error)}
                helperText={touched && error}
                // size='small'
                margin='none'
                fullWidth
                inputProps={{
                  ...params.inputProps,
                  autoComplete: 'new-password',
                  className:
                    'browser-default data-hj-allow ' +
                    params.inputProps.className,
                }}
              />
            )
          : props.renderInput
      }
    />
  )
}

export default React.memo(FormikAutocomplete)
